import { render, staticRenderFns } from "./OperaShopWindow.vue?vue&type=template&id=00440784&scoped=true&"
import script from "./OperaShopWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopWindow.vue?vue&type=style&index=0&id=00440784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00440784",
  null
  
)

export default component.exports